/**
 * Created by razial on 23.07.2026.
 */

PrefabEditor.registerCommand("schema.refresh", (editor) => {
    editor.postMessage("schema.refreshed", Prefab.schema());
});

PrefabEditor.registerCommand("content.refresh", (editor) => {
    editor.postMessage("content.refreshed", editor.calculate());
});

PrefabEditor.registerCommand("assets.export", (editor) => {
    editor.exportChanges();
});

PrefabEditor.registerCommand("assets.refresh", (editor) => {
    editor.postMessage("assets.refreshed", editor.assets.listAssets());
});

PrefabEditor.registerCommand("assets.preview", (editor, data) => {
    editor.previewAsset(data);
});

PrefabEditor.registerCommand("assets.reset", (editor) => {
    editor.resetAssets();
});

PrefabEditor.registerCommand("bundle.create", (editor, data) => {
    editor.createBundle(data);
});

PrefabEditor.registerCommand("bundle.remove", (editor, data) => {
    editor.removeBundle(data);
});

PrefabEditor.registerCommand("asset.create", (editor, data) => {
    editor.createAsset(data);
});

PrefabEditor.registerCommand("asset.remove", (editor, data) => {
    editor.removeAsset(data);
});

PrefabEditor.registerCommand("property.update", (editor, data) => {
    editor.updateProperty(data);
});

PrefabEditor.registerCommand("params.update", (editor, data) => {
    editor.updateParams(data);
});

PrefabEditor.registerCommand("component.update", (editor, data) => {
    editor.updateComponent(data);
});

PrefabEditor.registerCommand("component.add", (editor, data) => {
    editor.addComponent(data);
});

PrefabEditor.registerCommand("component.remove", (editor, data) => {
    editor.removeComponent(data);
});

PrefabEditor.registerCommand("node.place", (editor, data) => {
    editor.placeNode(data);
});

PrefabEditor.registerCommand("node.rebuild", (editor, data) => {
    editor.rebuildNode(data);
});

PrefabEditor.registerCommand("camera.transform", (editor, data) => {
    editor.transformCamera(data);
});

PrefabEditor.registerCommand("selection.update", (editor, data) => {
    if (data.shadowNodeId) {
        editor.setSelection(data.shadowNodeId);
        return;
    }

    if (data.point) {
        const point = cc.pointApplyAffineTransform(data.point, PrefabEditorHelper.transformFromFrameSpace());

        const shadowNode = PrefabEditorHelper.hitTest(editor.prefabShadowNode, point);
        if (shadowNode) {
            editor.setSelection(shadowNode.shadowNodeId);
        }
    }
});
